<template>
  <div class="barcode-scanner">
    <div class="card">
      <div class="card-header bg-primary text-white">Lector de Código de Barras</div>
      <div class="card-body">
        <video id="barcode-scanner" class="w-100"></video>
        <p class="mt-3">Código Detectado: {{ scannedCode }}</p>
        <button class="btn btn-danger mt-2" @click="stopScanner">Detener</button>
      </div>
    </div>
    <div class="map-container mt-4">
      <div class="card">
        <div class="card-header bg-primary text-white">Seleccionar Ubicación</div>
        <div class="card-body">
          <div id="map" class="map"></div>
          <p class="mt-3">Ubicación Seleccionada: {{ selectedLocation.lat }}, {{ selectedLocation.lng }}</p>
          <button class="btn btn-success mt-2" @click="saveLocation">Guardar Ubicación</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Quagga from 'quagga';
import L from 'leaflet';

export default {
  data() {
    return {
      scannedCode: '',
      map: null,
      selectedLocation: { lat: 0, lng: 0 }
    };
  },
  mounted() {
    this.startScanner();
    this.$nextTick(() => {
      this.initMap();
    });
  },
  methods: {
    startScanner() {
      Quagga.init({
        inputStream: {
          type: 'LiveStream',
          target: document.querySelector('#barcode-scanner'),
          constraints: {
            width: 640,
            height: 480,
            facingMode: 'environment'
          }
        },
        decoder: {
          readers: ['ean_reader', 'code_128_reader', 'upc_reader']
        }
      }, (err) => {
        if (err) {
          console.error('Error al iniciar Quagga:', err);
          return;
        }
        Quagga.start();
      });

      Quagga.onDetected(this.onBarcodeDetected);
    },
    onBarcodeDetected(result) {
      this.scannedCode = result.codeResult.code;
      Quagga.stop();
    },
    stopScanner() {
      Quagga.stop();
    },
    initMap() {
  this.$nextTick(() => {
    const mapElement = document.getElementById("map");
    if (!mapElement) {
      console.error("El contenedor del mapa no se ha encontrado.");
      return;
    }
    
    this.map = L.map(mapElement).setView([0, 0], 2);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(this.map);

    this.map.on("click", (e) => {
      this.selectedLocation = e.latlng;
      L.marker([e.latlng.lat, e.latlng.lng]).addTo(this.map)
        .bindPopup("Ubicación seleccionada").openPopup();
    });
  });
    },

    saveLocation() {
      alert(`Ubicación guardada: ${this.selectedLocation.lat}, ${this.selectedLocation.lng}`);
    }
  }
};
</script>

<style scoped>
.barcode-scanner {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
}
.card {
  width: 400px;
  padding: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}
.map-container {
  width: 100%;
  max-width: 600px;
}
.map {
  width: 100%;
  height: 300px;
  min-height: 300px;
}
</style>
